// v4 (D7): Admin > Feedback's data: what users sent through the Director (report_problem, send_feedback, unmet asks),
// read from GET /api/admin/feedback and checked here (pure; unit-tested in help-spending.test.ts).
export type FeedbackKind = "problem" | "feedback" | "unmet";
export type FeedbackStatus = "new" | "seen" | "done";
export type FeedbackItem = {
  id: string;
  kind: FeedbackKind;
  text: string;
  status: FeedbackStatus;
  createdAt: string;
  user: { id: string | null; name: string | null; email: string | null };
  projectId: string | null;
  projectTitle: string | null;
  emailed: string | null;
  context: { path?: string; jobIds?: string[]; sentryEventIds?: string[]; screenshot?: boolean; via?: "director" | "button" };
};

export const KIND_LABEL: Record<FeedbackKind, string> = { problem: "Problem", feedback: "Idea", unmet: "Couldn't do" };
export const FILTERS: { id: "" | FeedbackKind; label: string }[] = [
  { id: "", label: "All" },
  { id: "unmet", label: "Couldn't do" },
  { id: "problem", label: "Problems" },
  { id: "feedback", label: "Ideas" },
];

const obj = (v: unknown): Record<string, unknown> => (v && typeof v === "object" ? (v as Record<string, unknown>) : {});
const strs = (v: unknown) => (Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : undefined);
const strOrNull = (v: unknown) => (typeof v === "string" && v ? v : null);

export function normFeedback(raw: unknown): FeedbackItem[] {
  return (Array.isArray(obj(raw).items) ? (obj(raw).items as unknown[]) : []).map(obj).flatMap((o) => {
    if (typeof o.id !== "string" || typeof o.text !== "string" || !["problem", "feedback", "unmet"].includes(o.kind as string)) return [];
    const u = obj(o.user);
    const c = obj(o.context);
    return [
      {
        id: o.id,
        kind: o.kind as FeedbackKind,
        text: o.text,
        status: (["new", "seen", "done"].includes(o.status as string) ? o.status : "new") as FeedbackStatus,
        createdAt: typeof o.createdAt === "string" ? o.createdAt : "",
        user: { id: strOrNull(u.id), name: strOrNull(u.name), email: strOrNull(u.email) },
        projectId: strOrNull(o.projectId),
        projectTitle: strOrNull(o.projectTitle),
        emailed: strOrNull(o.emailed),
        context: { ...(typeof c.path === "string" ? { path: c.path } : {}), ...(strs(c.jobIds) ? { jobIds: strs(c.jobIds) } : {}), ...(strs(c.sentryEventIds) ? { sentryEventIds: strs(c.sentryEventIds) } : {}), ...(typeof c.screenshot === "string" && c.screenshot ? { screenshot: true } : {}), ...(c.via === "button" ? { via: "button" as const } : {}) },
      },
    ];
  });
}

